import { render, staticRenderFns } from "./DataTable2Page.vue?vue&type=template&id=20a4ef02&"
import script from "./DataTable2Page.vue?vue&type=script&lang=js&"
export * from "./DataTable2Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports